module.exports = __webpack_public_path__ + "img/R@2x.c0bb5fe.jpg";